/* Keep guests' provider work behind intent; refresh signed-in header balances after page load. */
(function () {
  if (window.__destructiveStampedIntent) return;
  window.__destructiveStampedIntent = true;
  var config = window.DestructiveRewardsConfig;
  if (!config) return;
  var providerPromise = null;
  var popupPromise = null;
  var opening = false;
  var openGeneration = 0;
  var activeOpen = null;
  var reviewObserver = null;
  var cancelPopupWait = null;
  var headerLoadTimer = null;
  var headerLoadListener = null;

  function script(id, url) {
    return new Promise(function (resolve, reject) {
      var node = document.getElementById(id);
      var owned = !node;
      if (!node) {
        node = document.createElement('script');
        node.id = id;
        node.src = url;
        node.async = true;
        if (id === 'stamped-script-widget') node.setAttribute('data-auto-init', 'false');
      }
      if (node.dataset.loaded === 'true') { resolve(); return; }
      var timer = setTimeout(function () { finish(new Error('Widget load timeout')); }, 10000);
      function finish(error) {
        clearTimeout(timer);
        node.removeEventListener('load', loaded);
        node.removeEventListener('error', failed);
        if (error) {
          if (owned) node.remove();
          reject(error);
        } else {
          node.dataset.loaded = 'true';
          resolve();
        }
      }
      function loaded() { finish(); }
      function failed() { finish(new Error('Widget unavailable')); }
      node.addEventListener('load', loaded, { once: true });
      node.addEventListener('error', failed, { once: true });
      if (owned) document.head.appendChild(node);
    });
  }

  window.initializeStamped = function () {
    if (!window.StampedFn || typeof window.StampedFn.init !== 'function') throw new Error('Widget unavailable');
    if (!window.isInitializedStamped) window.StampedFn.init({ apiKey: config.apiKey, sId: '243520' });
  };
  window.loadStampedWidgets = function () {
    if (providerPromise) return providerPromise;
    providerPromise = (window.StampedFn ? Promise.resolve() : script('stamped-script-widget', 'https://cdn1.stamped.io/files/widget.min.js?skip=true'))
      .then(function () { window.initializeStamped(); })
      .catch(function (error) { providerPromise = null; throw error; });
    return providerPromise;
  };
  function loadPopup() {
    if (window.openDestructiveRewards) return Promise.resolve();
    if (!popupPromise) popupPromise = script('DestructiveRewardsPopupScript', config.popupAsset)
      .catch(function (error) { popupPromise = null; throw error; });
    return popupPromise;
  }
  function loadRewards() {
    // Install branding/value listeners before provider initialisation emits events.
    return loadPopup().then(window.loadStampedWidgets);
  }
  function cancelHeaderBalance() {
    clearTimeout(headerLoadTimer);
    headerLoadTimer = null;
    if (headerLoadListener) window.removeEventListener('load', headerLoadListener);
    headerLoadListener = null;
  }
  function scheduleHeaderBalance() {
    cancelHeaderBalance();
    if (config.authenticated !== true || !document.querySelector('[data-header-rewards-points-source]')) return;
    var generation = openGeneration;
    function queue() {
      headerLoadListener = null;
      headerLoadTimer = setTimeout(function () {
        headerLoadTimer = null;
        if (generation !== openGeneration) return;
        // Reuse the validated balance formatter and provider initialisation,
        // without opening a panel or starting provider-frame readiness polling.
        loadPopup().then(function () {
          if (generation === openGeneration) return window.loadStampedWidgets();
        }).catch(function () {});
      }, 0);
    }
    if (document.readyState === 'complete') queue();
    else {
      headerLoadListener = queue;
      window.addEventListener('load', headerLoadListener, { once: true });
    }
  }
  function popupReady() {
    try {
      var api = window.StampedFn;
      var doc = api && api.getLauncherWindow && api.getLauncherWindow();
      return !!(doc && doc.body && doc.querySelector('.stamped-rewards-window') && window.openDestructiveRewards);
    } catch (error) { return false; }
  }
  function waitForPopup() {
    return new Promise(function (resolve, reject) {
      var attempts = 0;
      var timer = null;
      function finish(error) {
        clearTimeout(timer);
        cancelPopupWait = null;
        if (error) reject(error); else resolve();
      }
      cancelPopupWait = function () { finish(new Error('Page inactive')); };
      function check() {
        if (popupReady()) { finish(); return; }
        if (++attempts >= 80) { finish(new Error('Rewards unavailable')); return; }
        timer = setTimeout(check, 100);
      }
      check();
    });
  }
  function feedback(opener, failed) {
    var status = document.getElementById('DestructiveRewardsLoadStatus');
    if (!status) {
      status = document.createElement('span');
      status.id = 'DestructiveRewardsLoadStatus';
      status.className = 'RewardsLoadStatus';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      (opener && opener.parentNode || document.body).appendChild(status);
    }
    status.textContent = failed ? config.loadingSlow : config.loading;
    if (failed) {
      var link = document.createElement('a');
      link.href = config.path;
      link.setAttribute('data-rewards-full-page', '');
      link.textContent = config.fullPage;
      status.appendChild(link);
    }
    return status;
  }
  function openRewards(opener) {
    if (opening) return;
    opening = true;
    var generation = ++openGeneration;
    // Preserve the clicked product context while provider scripts load; the
    // theme may replace the trigger before the popup is ready.
    var productWrapper = opener && opener.closest && opener.closest('.stamped-earn-points-wrapper');
    if (opener) opener.setAttribute('aria-busy', 'true');
    var status = feedback(opener, false);
    activeOpen = { opener: opener, status: status };
    function current() {
      if (generation !== openGeneration) throw new Error('Page inactive');
    }
    loadPopup().then(function () {
      current();
      return window.loadStampedWidgets();
    }).then(function () {
      current();
      return waitForPopup();
    }).then(function () {
      current();
      if (!window.openDestructiveRewards(opener, productWrapper)) throw new Error('Rewards unavailable');
      status.remove();
      var url = new URL(window.location.href);
      if (url.searchParams.get('open_rewards') === '1') {
        url.searchParams.delete('open_rewards');
        window.history.replaceState(window.history.state, '', url.href);
      }
    }).catch(function () { if (generation === openGeneration) feedback(opener, true); }).finally(function () {
      if (generation !== openGeneration) return;
      activeOpen = null;
      opening = false;
      if (opener) opener.removeAttribute('aria-busy');
    });
  }
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = event.target && event.target.closest && event.target;
    if (!target) return;
    var link = target.closest('a[href]');
    var url = link && new URL(link.href, window.location.href);
    var rewardsIntent = target.closest('[data-action="open-stamped-rewards"]');
    if (!link && !rewardsIntent) rewardsIntent = target.closest('.stamped-earn-points-trigger');
    if (link && (link.hasAttribute('data-rewards-full-page') || link.closest('.breadcrumbs'))) return;
    if (rewardsIntent || url && url.origin === window.location.origin && url.pathname === config.path) {
      event.preventDefault();
      openRewards(link || rewardsIntent);
    } else if (target.closest('.stamped-product-reviews-badge, #stamped-main-widget, #stamped-reviews-widget, a[href*="#stamped"]')) {
      window.loadStampedWidgets().catch(function () {});
    }
  });
  function openProductReviewFromEmail() {
    if (window.location.hash !== '#write-a-review' || !document.body.classList.contains('template-product')) return false;
    var canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) return false;
    try {
      var productUrl = new URL(canonical.href, window.location.href);
      var handle = productUrl.pathname.match(/\/products\/([a-z0-9][a-z0-9-]*)\/?$/i);
      if (productUrl.origin !== window.location.origin || !handle) return false;
      var reviewUrl = new URL('/a/review/write', window.location.origin);
      reviewUrl.searchParams.set('product', handle[1]);
      window.location.replace(reviewUrl.href);
      return true;
    } catch (error) { return false; }
  }
  function boot() {
    // Stamped's tracked email URLs preserve fragments but do not expose handles in Liquid.
    if (openProductReviewFromEmail()) return;
    if (reviewObserver) { reviewObserver.disconnect(); reviewObserver = null; }
    if (new URLSearchParams(window.location.search).get('open_rewards') === '1') openRewards(null);
    else if (config.rewardsPage) loadRewards().catch(function () { feedback(null, true); });
    else scheduleHeaderBalance();
    var productRewards = document.querySelector('[data-product-reward-money]');
    var reviews = document.querySelectorAll('#stamped-main-widget, #stamped-reviews-widget, [data-product-reward-money]');
    if (!reviews.length || config.rewardsPage) return;
    if (!window.IntersectionObserver) {
      // Preserve reviews in older browsers which cannot observe the section.
      (productRewards ? loadRewards() : window.loadStampedWidgets()).catch(function () {});
      return;
    }
    reviewObserver = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      reviewObserver.disconnect();
      reviewObserver = null;
      (productRewards ? loadRewards() : window.loadStampedWidgets()).catch(function () {});
    }, { rootMargin: '400px 0px' });
    Array.prototype.forEach.call(reviews, function (node) { reviewObserver.observe(node); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  window.addEventListener('pagehide', function () {
    openGeneration++;
    cancelHeaderBalance();
    opening = false;
    if (activeOpen) {
      if (activeOpen.opener) activeOpen.opener.removeAttribute('aria-busy');
      activeOpen.status.remove();
      activeOpen = null;
    }
    if (reviewObserver) { reviewObserver.disconnect(); reviewObserver = null; }
    if (cancelPopupWait) cancelPopupWait();
  });
  window.addEventListener('pageshow', function (event) { if (event.persisted) boot(); });
}());
